// whocare: remembered state of the icon rail (collapsed / expanded), kept per browser.

const RAIL_KEY = 'whocare.rail';

/** The icon rail can be widened to show labels; the choice is remembered per browser. */
export const readRailExpanded = (): boolean => {
  try {
    return window.localStorage.getItem(RAIL_KEY) === 'expanded';
  } catch {
    return false;
  }
};

export const writeRailExpanded = (expanded: boolean) => {
  try {
    if (expanded) {
      window.localStorage.setItem(RAIL_KEY, 'expanded');
    } else {
      window.localStorage.removeItem(RAIL_KEY);
    }
  } catch {
    // ignore
  }
};
